/* eslint-disable react/no-multi-comp */
import React from "react";
import { DisplayComponent } from "scmp-sdk/components/newsletter/newsletter-widget/enums";
import type { NewsletterHook } from "scmp-sdk/components/newsletter/newsletter-widget/types";

import { HomepageThemeFindOutMore } from "./homepage-theme-find-out-more";
import { SignUpNewsletter } from "./homepage-theme-sign-up-newsletter";
import { SignUpSuccessMessage } from "./homepage-theme-sign-up-success-message";

export const useHomepageRender: NewsletterHook = onSuccess => ({
  [DisplayComponent.FindOutMore]: _props => <HomepageThemeFindOutMore />,
  [DisplayComponent.SignUpNewsletter]: props => (
    <SignUpNewsletter isShowOverlaySignUp onSuccess={onSuccess} {...props} />
  ),
  [DisplayComponent.SignUpSuccessMessage]: _props => <SignUpSuccessMessage />,
});
